import { Stack } from "@mui/material";

function KsbToolbarAdmin({ children }) {
  return (
    <Stack direction="row" spacing={1}>
      {children}
    </Stack>
  );
}

export default KsbToolbarAdmin;
